// extracted by mini-css-extract-plugin
export var tabHeaderBar = "tabs-module--tabHeaderBar--Y8z7l";
export var tabHeaderButton = "tabs-module--tabHeaderButton--2uIPE";
export var tabHeaderButtonTextLong = "tabs-module--tabHeaderButtonTextLong--dLB09";
export var tabHeaderButtonTextShort = "tabs-module--tabHeaderButtonTextShort--1Wew2";
export var tabHeaderButtonActive = "tabs-module--tabHeaderButtonActive--3jFQx";
export var tabHeaderButtonInactive = "tabs-module--tabHeaderButtonInactive--Y47eA";
export var tabContent = "tabs-module--tabContent--_yLtR";